<!------------------------------------------------------------------------------
 File: SearchBar
 Created by keni.
 with: IntelliJ IDEA
 Date: 05/04/2018
 Time: 11:00
------------------------------------------------------------------------------->
<template>
    <div data-search-bar class="d-flex align-items-center"
         :class="[
             {
                    'justify-content-end':searchActive,
                    'justify-content-between':!searchActive,
                },main_cls,input_elm_width
         ]"
    >

        <div v-if="(typeof title !== 'undefined' && title !== null) && searchActive === false"
        >
            <div class="d-flex align-items-center">
                <!--my-0 ml-0 mr-2 animated pulse waves-effect waves-light  btn-floating&#45;&#45;single btn-sm-->
                <add_to_bookmark
                        data-element-type="add_to_bookmark"
                        class="btn btn-info btn-floating btn-sm p-0 m-0 mr-1"
                        v-show="readBookmark() !== null"
                        :store="readBookmark('store')"
                        :route="readBookmark('route')"
                >
                    add to bookmark component
                </add_to_bookmark>

                <!--the refresh data button-->
                <div v-if="typeof show_refresh != 'undefined'" data-element-type="refresh-results"
                     class="btn btn-secondary btn-floating btn-sm p-0 m-0 mr-1"
                     v-on:click="$emit('refresh_event')">
                    <i class="material-icons">refresh</i>
                </div>

                <!--the title-->
                <h3 class="p-0 h3-responsive">{{title}}</h3>
            </div>
        </div>

        <div data-ref="searchBar-container"
             :class="input_elm_width">
            <div class="d-flex align-items-center"
                 :class="{
                        'justify-content-end':direction!='ltr',
                        'justify-content-start':direction=='ltr',
                     }"
            >

                <span class="search-bar--input-wrapper" :class="input_elm_width">
                    <input v-model="searchResultModel"
                           ref="search"
                           v-on:keyup.enter="submit_event()"
                           class="watch-transition--slow"
                           :class="{
                            'search-bar--open':searchActive,
                            'search-bar--input-open':searchActive,
                            'search-bar--closed':!searchActive,
                            'search-bar--input-closed':!searchActive,
                            'search-bar-input--ltr':direction=='ltr',
                            'search-bar-input--rtl':direction!='ltr',
                        }"
                           type="text"
                           :placeholder="limit_text"
                           :aria-label="limit_text"
                           title="search"
                    >
                </span>

                <!--the search icon-->

                <transition name="fade_fast">
                    <div v-if="searchActive"
                         class="search-bar-close-button"
                         data-search-close-before
                         v-on:click="close_search()"
                    >
                        <i class="material-icons" aria-hidden="true">close</i>
                    </div>
                    <div
                            v-else
                            :data-direction="direction"
                            class="search-bar-button"
                            v-on:click="searchActive = true"
                    >
                        <i class="material-icons" aria-hidden="true"
                        >search</i>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'search-bar',
        components: {},
        propsA:{
            bookmark:{
                type:function(){
                    return Array|Object;
                }
            },
            prev_filter_string:{
                type:String
            },
            title:{
                type:String
            }
        },
        props: [
            'input_width_class',
            'cls',
        	'show_refresh',
            'bookmark',
            'prev_filter_string',
            'title',
            'set_direction',
            'value',
            'name',
            'label',
            'trigger_route',
            'close_search_action', //boolean
            'open_on_load',
            'min_input' // adds limit title
        ],
        created() {
        },
        destroyed() {
        },
        mounted() {
            if (typeof this.input_width_class !== 'undefined' && this.input_width_class !== null) {
                this.input_elm_width = this.input_width_class;
            }
            if (typeof this.label !== 'undefined' && this.label !== null) {
                this.input_label = this.label;
            }
            if (typeof this.cls !== 'undefined' && this.cls !== null) {
                this.main_cls = this.cls;
            }
            if (typeof this.set_direction !== 'undefined' && this.set_direction !== null) {
                this.direction = this.set_direction;
            }
            if (typeof this.value !== 'undefined' && this.value !== null) {
                this.searchResultModel = this.value.trim() || '';
                if (this.searchResultModel != '') {
                    this.searchActive = true;
                }

            }
            if (typeof this.min_input !== 'undefined' && this.min_input !== null) {
                this.limit_text = `${this.input_label} (min ${this.min_input})`;
            }

            this.$nextTick(function() {
                if (typeof this.open_on_load !== 'undefined' && this.open_on_load !== null) {
                    this.searchActive = true;
                }
                if (typeof this.prev_filter_string !== 'undefined' && this.prev_filter_string !== null) {
                    this.searchResultModel = this.prev_filter_string;
                    this.searchActive = true;
                }
            });
        },
        data() {
            return {
                input_elm_width:'',
                main_cls:'mb-3',
                input_label: 'Search',
                searchResultModel: '',
                searchActive: false,
                direction: 'rtl', // ltr
                limit_text: 'Search'
            };
        },
        methods: {

            readBookmark(returnProp){
                let bookMarkOk = typeof this.bookmark !== 'undefined' && this.bookmark !== null;

//                console.log('readBookmark', 'bookMarkOk',bookMarkOk);
                if(!bookMarkOk){
                    return null;
                }
                let test = this.bookmark.hasOwnProperty('store');
//console.log('readBookmark', 'test',test);
                if(!test){
//                    console.log('readBookmark', '!test',false);

                    return null;
                }
                if(!_.isUndefined(returnProp) &&  returnProp.length > 0){
//                    console.log('readBookmark', 'returnProp',returnProp,this.bookmark[returnProp]);
                    return this.bookmark[returnProp];
                }
            },
            close_search() {
	            // console.log('test close_search','close_search',this.searchActive,'typeof this.close_search_action',typeof this.close_search_action);

	            this.searchActive = false;
                if (typeof this.close_search_action !== 'undefined' && this.close_search_action !== null) {
                    this.$emit('close_search_event', true);
                }else{
                	// console.log('this.trigger_route',this.trigger_route);
                	if(typeof this.trigger_route !== 'undefined' && this.trigger_route !== null){
		                window.location.href = this.trigger_route;
	                }
                }

            },
            submit_event() {
                // console.log('val',this.searchResultModel);
                this.$emit('execute_search', this.searchResultModel);
                if (typeof this.trigger_route !== 'undefined' && this.trigger_route !== null) {
                    let uri = this.trigger_route + '?' + this.name + '=' + encodeURIComponent(this.searchResultModel);
                    window.location.href = uri;
                    // console.log('x',this.trigger_route + '?' + this.name + '=' + this.searchResultModel);
                }
            }
        },
        watch: {
            searchResultModel: function(value) {
                this.$emit('search_event', value);
                //				console.log('value', value);

            },
            searchActive: function(active) {
                // console.log('active',active);
                if (!active) {
                    this.searchResultModel = '';
                }
                else {

                    this.$nextTick(function() {
                        this.$refs.search.focus();
                    });
                }
            }
        },
        computed: {}
    };
</script>

<style scoped>
.search-bar--input-wrapper{
    display: block;
    overflow: hidden;
}
.search-bar--input-open{
    width: 100% !important;
}
.search-bar--input-closed{
    width: 0% !important;
}
</style>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/SearchBar.vue?a41cb87e